export default "__VITE_ASSET__xywNIKdx__"